
import React from 'react'
import { FileText, ExternalLink, Plus, Check, Archive } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'

interface ResourceCardProps {
  resource: any
  showBadge?: boolean
  showAddButton?: boolean
  showArchiveButton?: boolean
  isAdded?: boolean
  onAddResource?: (resourceId: string) => void
  onArchiveResource?: (resourceId: string) => void
}

const ResourceCard = ({ 
  resource, 
  showBadge = false, 
  showAddButton = false,
  showArchiveButton = false,
  isAdded = false,
  onAddResource,
  onArchiveResource
}: ResourceCardProps) => (
  <div className="p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
    <div className="flex items-start justify-between">
      <div className="flex items-start gap-3 flex-1">
        <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
          <FileText className="w-4 h-4 text-blue-500" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            {resource.priority && (
              <span className="w-2 h-2 bg-red-500 rounded-full"></span>
            )}
            <h4 className="font-medium text-gray-900 text-sm truncate">{resource.title}</h4>
          </div>
          {resource.description && (
            <p className="text-xs text-gray-600 line-clamp-2 mb-2">{resource.description}</p>
          )}
          <div className="flex items-center gap-2">
            {showBadge && resource.domain && (
              <Badge variant="outline" className="text-xs">
                {resource.domain}
              </Badge>
            )}
            {resource.module && (
              <span className="text-xs text-gray-500">{resource.module}</span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {showAddButton && onAddResource && (
            <Button
              variant="outline"
              size="sm"
              disabled={isAdded}
              onClick={() => onAddResource(resource.id)}
            >
              {isAdded ? (
                <>
                  <Check className="w-3 h-3 mr-1" />
                  Added
                </>
              ) : (
                <>
                  <Plus className="w-3 h-3 mr-1" />
                  Add
                </>
              )}
            </Button>
          )}
          {showArchiveButton && onArchiveResource && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => onArchiveResource(resource.id)}
            >
              <Archive className="w-3 h-3 mr-1" />
              Archive
            </Button>
          )}
          {resource.file_url && (
            <Button
              variant="ghost"
              size="sm"
              className="p-1 h-auto"
              onClick={() => window.open(resource.file_url!, '_blank')}
            >
              <ExternalLink className="w-3 h-3" />
            </Button>
          )}
        </div>
      </div>
    </div>
  </div>
)

export default ResourceCard
